import { graphql } from '~publish/graphql'

export const DeleteSavedViewMutation = graphql(/* GraphQL */ `
  mutation DeleteSavedView($input: DeleteSavedViewInput!) {
    deleteSavedView(input: $input) {
      __typename
      ... on DeleteSavedViewSuccess {
        id
      }
      ... on MutationError {
        message
      }
    }
  }
`)
